<template>
  <div class="app-main-inner">
    <el-dialog
      :visible="visible"
      :title="$t('CargoMsg.Cargo_SelectVoucherDate')"
      :width="dialogWidth"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      top="15vh"
      custom-class="date-selector"
    >
      <el-form :inline="true" label-width="80px" label-position="left">
        <div v-if="showAccountSetSelect" class="app-main-inner-row" style="padding: 0;">
          <el-form-item class="el-form-item-w300">
            <line-label slot="label" :label="$t('CargoMsg.Cargo_SetsOfBooksP')" />
            <el-select v-model="accountSetDDL" no="1" :placeholder="$t('CargoMsg.Cargo_PleaseSelectP')" filterable @change="accountSetChangeHandler">
              <el-option
                v-for="accountSet in accountSetDataProvider"
                :key="accountSet.uuid"
                :label="accountSet.name"
                :value="accountSet.uuid"
              />
            </el-select>
          </el-form-item>
        </div>
        <div v-if="source === 'writeOff' || isActualAmount || isInvoice || isJob" class="app-main-inner-row" style="padding: 0;">
          <el-form-item class="el-form-item-radio">
            <line-label slot="label" :label="$t('CargoMsg.Cargo_DateType')+'：'" />
            <el-radio-group v-model="dateType" no="2" :style="$selectByLang('', 'margin-left: 80px;')" @change="onDateTypeChange">
              <el-radio :label="0">{{ $t('FinanceManage.today') }}</el-radio>
              <el-radio :label="1">{{ $t('FinanceManage.thisMonthEnd') }}</el-radio>
              <el-radio :label="2">{{ $t('FinanceManage.previousMonthEnd') }}</el-radio>
              <template v-if="source === 'writeOff' || isActualAmount">
                <el-radio :disabled="!payReceiveDate" :label="3">{{ $t('CargoMsg.Cargo_PayReceiveDate') }}</el-radio>
                <el-radio :disabled="!verificationDate" :label="4">{{ $t('WriteOff.writeOffDate') }}</el-radio>
              </template>
              <template v-else-if="isInvoice">
                <el-radio :disabled="!invoiceDate" :label="5">{{ $t('CargoMsg.Cargo_InvoiceDate') }}</el-radio>
              </template>
            </el-radio-group>
          </el-form-item>
        </div>
        <div class="app-main-inner-row" style="padding: 0;">
          <el-form-item class="el-form-item-w200">
            <line-label slot="label" :label="$t('CargoMsg.Cargo_ProofDateP')" />
            <el-date-picker
              v-model="voucherDate"
              :disabled="isCommit && Number(dateType) >=3 && (invoiceDate || payReceiveDate || verificationDate)"
              type="date"
              no="3"
              style="width:120px;"
              :clearable="false"
              value-format="yyyy-MM-dd"
              :editable="false"
              @change="dateChangeHandler"
            />
          </el-form-item>
        </div>
        <div v-if="currentState==='ext'" class="app-main-inner-row row-grid" style="min-height: 200px;padding: 0;">
          <cargo-ag-grid
            :show-side-bar="false"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="nonGroupData"
            :auto-fit-content="false"
            :style="{width:'610px',height:'201px'}"
          />
        </div>
      </el-form>
      <div slot="footer" style="height: 25px;">
        <span style="position: absolute; right: 0; padding-right: 10px;">
          <el-button type="primary" no="4" style="width: 70px;margin-left: 5px;" @click="onOK">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
          <el-button no="5" style="width: 70px;margin-left: 5px;" @click="onCancel">{{ $t('CargoMsg.Cargo_Cancel') }}</el-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as FinanceInterfaceConstants from '@/class/cargo/model/parameters/FinanceInterfaceConstants'
import { getLoading } from '@/utils/utilBaseElement'
import VoucherUtils from '@/utils/VoucherUtils'
import StrUtils from '@/utils/StrUtils'
import ColumnUtils from '@/utils/ColumnUtils'
import { query } from '@/api/financeManage/accountSet'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'

export default {
  name: 'DateSelector',
  props: {
    visible: { type: Boolean, required: true },
    accountSet: { type: Object, default: null }, // 账套
    currentState: { type: String, default: 'normal' }, // normal/ext
    source: { type: String, default: '' },
    bizDataType: { type: Number, default: 0 },
    nonGroupData: { type: Array, default: () => [] },
    showAccountSetSelect: { type: Boolean, default: false },
    officeId: { type: Number, default: 0 },
    generateType: { type: String, default: 'commit' }
  },
  data() {
    return {
      dateType: -1,
      payReceiveDate: '',
      verificationDate: '',
      invoiceDate: '',
      voucherDate: moment().format('YYYY-MM-DD'), // 凭证日期
      accountSetDDL: null, // 账套
      accountSetDataProvider: [],
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowClicked: this.onRowClicked,
        onRowDoubleClicked: this.onOK
      },
      gridParams: {},
      rowData: []
    }
  },
  computed: {
    columnDefs() {
      return [
        { headerName: this.$t('CargoMsg.Cargo_WriteOffSerialNumber'), field: 'actualAmountNo', hide: !this.isActualAmount, width: 140 },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', hide: !this.isActualAmount, width: 180,
          cellRenderer: (params) => { return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') } },
        { headerName: this.$t('CargoMsg.Cargo_OurBank'), field: 'ourBank', hide: !this.isActualAmount, width: 180 },
        { headerName: this.$t('CargoMsg.Cargo_BusinessNo'), field: 'jobNo', hide: !this.isJob, width: 180 },
        { headerName: this.$t('CargoMsg.Cargo_BusinessType'), field: 'lob', hide: !this.isJob, width: 140,
          cellRenderer: (params) => { return ColumnUtils.jobBussStateLabelFunc(params.value) } },
        { headerName: this.$t('CargoMsg.Cargo_MblNo'), field: 'mbl', hide: !this.isJob, width: 180 },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceNo'), field: 'invoiceNo', hide: !this.isInvoice, width: 140 },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceTitle'), field: 'title', hide: !this.isInvoice, width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_InvoiceDate'), field: 'invoiceDate', hide: !this.isInvoice, width: 160,
          cellRenderer: (params) => { return ColumnUtils.dateLabelFunc(params.value) } },
        { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billingNo', hide: !this.isBilling, width: 180 },
        { headerName: this.$t('CargoMsg.Cargo_AgentBillNo'), field: 'counterPartyBillingNo', hide: !this.isBilling, width: 180 },
        { headerName: this.$t('CargoMsg.Cargo_BillType'), field: 'billingType', hide: !this.isBilling, width: 140,
          cellRenderer: (params) => { return ColumnUtils.billingTypeLabFun(params.value) } },
        { headerName: this.$t('WriteOff.paymentNotificationNo'), field: 'billPaymentNo', hide: !this.isBillPayment, width: 140 },
        { headerName: this.$t('WriteOff.settleAccountsTo'), field: 'accountId', hide: !this.isBillPayment, width: 200,
          cellRenderer: (params) => { return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName') } },
        { headerName: this.$t('WriteOff.dateOfApplication'), field: 'inputDate', hide: !this.isBillPayment, width: 160,
          cellRenderer: (params) => { return ColumnUtils.dateLabelFunc(params.value) } }
      ]
    },
    isActualAmount() {
      return (this.bizDataType === FinanceInterfaceConstants.RECEIPT_INTERNAL.code ||
        this.bizDataType === FinanceInterfaceConstants.PAYMENT_INTERNAL.code ||
        this.bizDataType === FinanceInterfaceConstants.RECEIPT_FOREGIN.code ||
        this.bizDataType === FinanceInterfaceConstants.PAYMENT_FOREGIN.code ||
        this.bizDataType === FinanceInterfaceConstants.RECEIPT_PAYMENT.code ||
        this.bizDataType === FinanceInterfaceConstants.RECEIPT_PAYMENT_OFFSET.code ||
        this.bizDataType === FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT.code ||
        this.bizDataType === FinanceInterfaceConstants.PRE_RECEIPT_PAYMENT_CLEAR.code)
    },
    isJob() {
      return (this.bizDataType === FinanceInterfaceConstants.BIZ_COST.code)
    },
    isInvoice() {
      return (this.bizDataType === FinanceInterfaceConstants.INVOICE_RECEIVABLE.code ||
        this.bizDataType === FinanceInterfaceConstants.INVOICE_PAYABLE_OFFSET.code ||
        this.bizDataType === FinanceInterfaceConstants.INVOICE_PAYABLE.code)
    },
    isBilling() {
      return (this.bizDataType === FinanceInterfaceConstants.BILLING_OVERSEA.code)
    },
    isBillPayment() {
      return (this.bizDataType === FinanceInterfaceConstants.BILLPAYMENT.code)
    },
    dialogWidth() {
      if (this.currentState === 'ext' || this.source === 'writeOff' || this.isActualAmount) {
        return '550px'
      } else if (this.isInvoice) {
        return '420px'
      } else if (this.isJob) {
        return '330px'
      } else {
        return '295px'
      }
    },
    isCommit() {
      return this.generateType === 'commit'
    }
  },
  mounted() {
    if (this.showAccountSetSelect && this.officeId > 0) {
      this.loadAccount()
    }
    const voucherDate = LocalStorageUtilsNew.getConfiguration('VoucherDate')
    if (!voucherDate) this.voucherDate = moment().format('YYYY-MM-DD')
    if (voucherDate) {
      this.voucherDate = moment(voucherDate).format('YYYY-MM-DD')
    }
    if (this.nonGroupData.length > 0) {
      if (this.source === 'writeOff' || this.isActualAmount) {
        this.payReceiveDate = this.nonGroupData[0].payReceiveDate
        this.verificationDate = this.nonGroupData[0].verificationDate
        if (!this.isCommit) {
          for (let i = 1; i < this.nonGroupData.length; ++i) {
            const item = this.nonGroupData[i]
            if (this.payReceiveDate && this.payReceiveDate !== item.payReceiveDate) {
              this.payReceiveDate = ''
            }
            if (this.verificationDate && this.verificationDate !== item.verificationDate) {
              this.verificationDate = ''
            }
          }
        }
      } else if (this.isInvoice) {
        this.invoiceDate = this.nonGroupData[0].invoiceDate
        if (!this.isCommit) {
          for (let i = 1; i < this.nonGroupData.length; ++i) {
            const item = this.nonGroupData[i]
            if (this.invoiceDate !== item.invoiceDate) {
              this.invoiceDate = ''
              break
            }
          }
        }
      }
    }
  },
  methods: {
    loadAccount() {
      this.loading = getLoading()
      const params = {
        branchId: this.officeId,
        mode: 'office',
        loadFiscalPeriodInfoFlag: true, // 结账信息
        loadAccountingDocumentTypeFlag: false, // 凭证类型
        loadAccountTitleFlag: false, // 科目
        loadMappingDepartmentsFlag: false, // 部门的编码映射
        loadMappingStaffsFlag: false, // 职员的编码映射
        loadAccountingDocumentsRuleFlag: false // 凭证分组规则
      }
      query(params).then(res => {
        this.accountSetDataProvider = res.data.list
        if (this.accountSetDataProvider.length > 0) {
          if (this.source === 'writeOff') {
            const cacheAccountSetDDL = LocalStorageUtilsNew.getConfiguration('DateSelector_AccountSetDDL')
            let hasFound = false // 判断缓存中的key是否存在，存在则取缓存的数据，没有时则默认取第一个
            if (cacheAccountSetDDL) {
              for (const item of this.accountSetDataProvider) {
                if (item.uuid && item.uuid === cacheAccountSetDDL) {
                  this.accountSetDDL = item.uuid
                  this.accountSet = item
                  hasFound = true
                  break
                }
              }
            }
            if (!hasFound) {
              this.accountSetDDL = this.accountSetDataProvider[0].uuid
              this.accountSet = this.accountSetDataProvider[0]
            }
          } else {
            this.accountSetDDL = this.accountSetDataProvider[0].uuid
          }
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    accountSetChangeHandler(value) {
      console.log('accountSetChangeHandler:', value)
      this.accountSetDDL = value
      if (this.source === 'writeOff') {
        this.accountSet = this.accountSetDataProvider.find(item => {
          return item.uuid === value
        })
      }
    },
    dateChangeHandler(value) {
      console.log('dateChangeHandler:', value)
      this.voucherDate = value
      if (this.voucherDate) LocalStorageUtilsNew.setConfiguration('VoucherDate', this.voucherDate)
    },
    // 获取已经选中的日期
    selectedDate() {
      return this.voucherDate
    },
    // 获取已经选中的日期类型
    selectedDateType() {
      return this.dateType
    },
    // 确定
    onOK() {
      console.log('selectedDate', this.voucherDate)
      if (this.accountSet !== null) {
        const year = moment(this.voucherDate).year()
        const month = moment(this.voucherDate).month() + 1
        if (VoucherUtils.checkVoucherDateClosing(year, month, this.accountSet.fiscalPeriod)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_SVSFPHBC'))
          return
        }
      }
      if (this.accountSet.softwareVersions === 'WT' && !this.checkFiscalPeriod(this.voucherDate, this.accountSet.fiscalPeriod)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_RFPNMIS'))
        return
      }
      if (this.currentState === 'ext') {
        if (this.showAccountSetSelect && StrUtils.isEmpty(this.accountSetDDL)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSob'))
          return
        }
        this.addToLocalStorage()
        this.$emit('groupCommit')
      } else {
        this.addToLocalStorage()
        this.$emit('select')
      }
    },
    // 取消
    onCancel() {
      this.addToLocalStorage()
      this.$emit('cancel', '')
    },
    checkFiscalPeriod(voucherDate, fiscalPeriod) {
      for (const fiscal of fiscalPeriod) {
        if (!fiscal.closing && fiscal.beginDate && fiscal.endDate && moment(fiscal.beginDate).format('yyyy-MM-DD') <= moment(voucherDate).format('yyyy-MM-DD') && moment(fiscal.endDate).format('yyyy-MM-DD') >= moment(voucherDate).format('yyyy-MM-DD')) {
          return true
        }
      }
      return false
    },
    // 添加相关默认项到本地缓存
    addToLocalStorage() {
      if (this.source === 'writeOff') {
        if (this.accountSetDDL) {
          LocalStorageUtilsNew.setConfiguration('DateSelector_AccountSetDDL', this.accountSetDDL)
        }
      }
    },
    onDateTypeChange() {
      const oldVoucherDate = this.voucherDate
      const newDate = new Date()
      switch (this.dateType) {
        case 0:
          this.voucherDate = moment(newDate).format('YYYY-MM-DD')
          break
        case 1:
          this.voucherDate = moment(newDate).endOf('month').format('YYYY-MM-DD')
          break
        case 2:
          newDate.setDate(0)
          this.voucherDate = moment(newDate).format('YYYY-MM-DD')
          break
        case 3:
          this.voucherDate = this.payReceiveDate
          break
        case 4:
          this.voucherDate = this.verificationDate
          break
        case 5:
          this.voucherDate = this.invoiceDate
          break
      }
      if (this.voucherDate !== oldVoucherDate) {
        this.dateChangeHandler(this.voucherDate)
      }
    }
  }
}
</script>

<style lang="scss">
.date-selector {
  .el-dialog__body {
    padding: 10px !important;
  }
  .el-form-item-w200 {
    width: 200px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 120px;
    }
  }
  .el-form-item-w300 {
    width: 300px;
    margin-right: 2px;
    margin-bottom: 4px !important;
    .el-form-item__content {
      width: 220px;
      .el-input__inner {
        padding: 0px 6px !important;
      }
    }
  }
  .el-form-item-radio {
    .el-radio {
      margin-right: 10px;
      font-size: 12px;
    }
  }
}
</style>
